module.exports = __webpack_public_path__ + "media/puntos cardinales 2.1c01d709.mp4";